// Dependencias
import Api from '@/services/Api'
// methods
export default {
  fetchOutputs (token) {
    return Api().get('outputs', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchOutputs2 (params, token) {
    return Api().get('outputs/' + params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchOutputsEducational (token) {
    return Api().get('outputs/educational', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchOutputsEducational2 (params, token) {
    return Api().get('outputs/educational/' + params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  filter (params, token) {
    return Api().get('outputs/filter/' + params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  filter2 (id, params, token) {
    return Api().get('outputs/' + id + '/filter/' + params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  filterEducational (params, token) {
    return Api().get('outputs/educational/filter/' + params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  filterEducational2 (id, params, token) {
    return Api().get('outputs/educational/' + id + '/filter/' + params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchTransactions (token) {
    return Api().get('transactions', {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchArchives (token) {
    return Api().get('archives/get', {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchFundations (token) {
    return Api().get('fundations', {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  generateExcel (params, token) {
    return Api().post('outputs/EXCEL/', params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  }
}



// WEBPACK FOOTER //
// ./src/services/OutputsService.js